import React, { useMemo, useState } from 'react';

import { Menu, MenuItem } from '@material-ui/core';
import { map } from 'lodash';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import UploadMusicRow from './Row.jsx';

import '../ArtistDetailsUploadedMusic.scss';

const ArtistDetailsUploadedMusic = (props) => {
  const { songs, setSongs, songStatus, isLoading } = props;

  const [approveEl, setApproveEl] = useState(null);
  const [declineEl, setDeclineEl] = useState(null);

  const songsToRender = useMemo(() => {
    const statusValue = songStatus.value || 'ALL';

    if (statusValue === 'ALL') return songs;
    return songs.filter((song) => song.submission_status === statusValue);
  }, [songStatus, songs]);

  const handelApproveSong = (selectedItemId) => {
    const updatedSongs = map(songs, (song) => {
      if (song.id === selectedItemId) {
        return {
          ...song,
          submission_status: 'ACCEPTED',
        };
      }
      return song;
    });
    setSongs(updatedSongs);
  };

  const handleRejectSong = (selectedItemId, reason) => {
    const updatedSongs = map(songs, (song) => {
      if (song.id === selectedItemId) {
        return {
          ...song,
          submission_status: 'REJECTED',
          decline_reason: reason,
        };
      }
      return song;
    });
    setSongs(updatedSongs);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
        <div style={{ display: 'flex', height: '100%', overflow: 'hidden', flex: 1, width: '100%' }}>
          <TableContainer className="tbl_wraper tbl_wrap" component={Paper}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="table_font result">Result</TableCell>
                  <TableCell>Song Name</TableCell>
                  <TableCell>Artist</TableCell>
                  <TableCell>Date Added</TableCell>
                  <TableCell className="status">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <div className="table_initial_loader">
                    <CircularProgress />
                  </div>
                )}

                {songsToRender?.length === 0 && !isLoading ? (
                  <div className="table_initial_loader">
                    <h4
                      style={{
                        textAlign: 'center',
                        marginBottom: 20,
                        fontSize: 20,
                        lineHeight: '32px',
                        maxWidth: '60%',
                        marginInline: 'auto',
                      }}
                    >
                      No Songs Found
                    </h4>
                  </div>
                ) : (
                  songsToRender?.map((song, index) => (
                    <UploadMusicRow makeSongApprove={handelApproveSong} makeSongDecline={handleRejectSong} song={song} index={index} />
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <Menu
          id="lock-menu"
          className="dropdown-menu"
          anchorEl={declineEl}
          open={Boolean(declineEl)}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          onClose={() => setDeclineEl(null)}
        >
          <MenuItem className="declinedinfo">Your song has been declined because we have found some inappropriate words in it</MenuItem>
        </Menu>

        <Menu
          id="lock-menu"
          className="dropdown-menu"
          anchorEl={approveEl}
          open={Boolean(approveEl)}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          onClose={() => setApproveEl(null)}
        >
          <MenuItem className="declinedinfo1">Approve this song</MenuItem>
        </Menu>
      </div>
    </>
  );
};

export default ArtistDetailsUploadedMusic;

